import React, { useEffect, useMemo, useRef, useState } from "react";
import { RadioButton } from "carbon-components-react";
import { DateRangePicker, defaultStaticRanges, DefinedRange, Calendar } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { format, parseISO } from "date-fns";
import { useOutsideClick } from "system/helpers/hooks"; // theme css file
import styles from "./styles";

const DateRangeMobile = ({
  value,
  onChange,
  name,
  fromName,
  toName,
  onFormValueChange,
  dateFormat,
}: any) => {
  const checkDate = (date: string) => {
    const parsedDate: any = parseISO(date);
    return parsedDate != "Invalid Date" ? parsedDate : new Date();
  };

  const handlerChange = (val: any) => {
    const from = val["selection"].startDate; //&& format(val["selection"].startDate, "yyyy-MM-dd");
    const to = val["selection"].endDate; //&& format(val["selection"].endDate, "yyyy-MM-dd");
    onChange(format(from, dateFormat), `${name}.${fromName}`);
    onChange(format(to, dateFormat), `${name}.${toName}`);
  };

  const handlerChangeStartDate = (val: any) => {
    const from = val["selection"].startDate; //&& format(val["selection"].startDate, "yyyy-MM-dd");
    onChange(format(from, dateFormat), `${name}.${fromName}`);
  };

  const handlerChangeEndDate = (val: any) => {
    const to = val["selection"].endDate; //&& format(val["selection"].endDate, "yyyy-MM-dd");
    onChange(format(to, dateFormat), `${name}.${toName}`);
  };

  const ref = useRef(null);
  const [clickOutSide] = useOutsideClick(ref);

  const data = useMemo(() => {
    return {
      startDate: checkDate(value?.[fromName]),
      endDate: checkDate(value?.[toName]),
    };
  }, [value, fromName, toName]);


  const [showStart, setShowStart] = useState(false);
  const [showEnd, setShowEnd] = useState(false);

  useEffect(() => {
    setShowStart(false);
    setShowEnd(false);
  }, [clickOutSide]);

  const renderStaticRangeLabel = () => (
    <div css={styles.sectionTitle}>
      Time Period:
    </div>
  );  
     
  return (
    <div css={styles.container} ref={ref}>
      <DateRangePicker
        className="date-range__section"
        onChange={(item) => {
          handlerChange(item)
        }}
        months={1}
        moveRangeOnFirstSelection={false}
        renderStaticRangeLabel={renderStaticRangeLabel}
        ariaLabels={{}}
        inputRanges={[]}
        ranges={[
          {
            startDate: data?.startDate,
            endDate: data?.endDate,
            key: "selection",
          },
        ]}
        staticRanges={[
          {
            hasCustomRendering: true,
            range: () => ({}),
            isSelected() {
              return false;
            },
          },
          ...defaultStaticRanges,
        ]}
        direction="horizontal"
      />
      <div className="date-range__section">
        <div css={styles.sectionTitle}>Custom Period:</div>
        <div 
          css={styles.sectionContainer}
          onClick={() => {
            setShowEnd(false);
            setShowStart(true);
            }}
          >
          <div css={styles.sectionText}>Start Date</div>
            {showStart && 
              <Calendar
                displayMode="dateRange"
                ranges={[
                  {
                    startDate: data?.startDate,
                    endDate: data?.endDate,
                    key: "selection",
                  },
                ]}
                css={styles.mobileCalendar}
                showMonthAndYearPickers={false}
                weekdayDisplayFormat={'EEEEE'}
                onChange={(item) => {
                  handlerChangeStartDate({
                    "selection" : {
                      startDate: item,
                      key: "selection",
                    }
                  });
                }}
              />}
              {`${format(data?.startDate, dateFormat)}`}
        </div>
        <div
          css={styles.sectionContainer}
          onClick={() => {
            setShowStart(false)
            setShowEnd(true)
            }}
        >
          <div css={styles.sectionText}>End Date</div>
            {`${format(data?.endDate,dateFormat)}`}
          {showEnd && 
            <Calendar
              displayMode="dateRange"
              ranges={[
                {
                  startDate: data?.startDate,
                  endDate: data?.endDate,
                  key: "selection",
                },
              ]}
              css={styles.mobileCalendar}
              showMonthAndYearPickers={false}
              weekdayDisplayFormat={'EEEEE'}
              onChange={(item) => {
                  handlerChangeEndDate({
                    "selection" : {
                      endDate: item,
                      key: "selection",
                    }
                  });
                }}
            />}
        </div>
      </div>
    </div>
  );
};

export default DateRangeMobile;